import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import * as App from '../../app'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Utils from './utils'

export const pageChangeEpic = (prefix: string) => (
  action$: ReduxObservable.ActionsObservable<Actions.PaginationAction>,
  store: Redux.Store<ApplicationState>,
  {window}: App.Dependencies,
) => action$.ofType(Utils.goToPageConstant(prefix))
  .map((action) => ({action, params: new window.URLSearchParams(window.location.search)}))
  .do(({action, params}) =>
    params.has(Constants.PageNumberParam) ?
      params.set(Constants.PageNumberParam, Math.max(1, action.pageNumber)) :
      params.append(Constants.PageNumberParam, Math.max(1, action.pageNumber)))
  .map(({params}) => `${window.location.pathname}?${params}`)
  .map(Router.replace)



// WEBPACK FOOTER //
// ./src/components/pager/epic.ts